import React, { Component } from 'react';
import TableData from '../component/TableData.js';
import TableHead from '../component/TableHead.js';
import axios from 'axios';
import {path,mail} from './routes.js';
import checkmark from '../asset/img/checkmark.png';
import denied from '../asset/img/denied.png';
import Modal from 'react-modal';
import Input from '../component/Input.js';
import loader from '../asset/img/loader.gif';
import Validation from './Validation.js';
import SelectBox from '../component/Select.js';

export default class ViewASMOrders extends Component{
	constructor(props){
		super(props);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.onclick = this.onclick.bind(this);
		this.cancelOrder = this.cancelOrder.bind(this);
		this.changeStatus = this.changeStatus.bind(this);
		this.getOrders = this.getOrders.bind(this);
		this.handleInput = this.handleInput.bind(this);
		this.loadingFunc = this.loadingFunc.bind(this);
		this.orderChangeEmail = this.orderChangeEmail.bind(this);
		this.createDateObject = this.createDateObject.bind(this);
		this.editTrackingNumber = this.editTrackingNumber.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.state = {
			orders:[],
			cancelID:0,
			modalIsOpen:false,
			approval:'',
			startDate:'',
			endDate:'',
			year:'',
			loading:false
		};
	}

	createDateObject(dateStringOne){ //method that creates a date object after it has passed the date validation format. used to determine whether or not a date is real, and to compare dates against eachother
		let datepartsOne;
    let dateOne;
    let dateConcat;
    let dateYear;
    let dateparts;
    	if(dateStringOne.indexOf("/") !== -1){ //check to see if a date contains a slash. split date string on slash if it does
    		datepartsOne = dateStringOne.split("/");
    		if(datepartsOne.length === 3){ //if the length of the array that contains the split string is 3, then the date only contained slashes
    			if(datepartsOne[2].length === 4){ //check to see if year given was full year (i.e. 2019) or abreviated (i.e. 19)
    				dateOne = new Date(dateStringOne);
    			}else{
    				dateConcat = datepartsOne[0]+"/"+datepartsOne[1]+"/20"+datepartsOne[2]; //if abbreviated, make it full length
    				dateOne = new Date(dateConcat);
    			}
    		}else{ //date contains a slash and a dash
    			if(datepartsOne[0].indexOf("-") !== -1){ //dash is contained in the first part of date string
    				dateYear = datepartsOne[1];
    				if(dateYear.length === 2){ //check whether or not year was abbreviated
    					dateYear = "20"+dateYear;
    				}
    				let monthDay = datepartsOne[0].split("-");
    				dateConcat = dateYear+"-"+monthDay[0]+"-"+monthDay[1]; //ISO format for date object
    				dateOne = new Date(dateConcat);
    			}else{ //dash is contained in second part of date string
    				let dateparts2 = datepartsOne[1].split("-");
    				dateYear = dateparts2[1];
    				if(dateYear.length === 2){ //check whether or not year was abbreviated
    					dateYear = "20"+dateYear;
    				}
    				dateConcat = dateYear+"-"+datepartsOne[0]+"-"+dateparts2[0]; //ISO format for date object
    				dateOne = new Date(dateConcat);
    			}
    		}
    	}else{
    		datepartsOne = dateStringOne.split("-");
    		if(datepartsOne.length === 3){  //date only contains dashes
    			dateYear = datepartsOne[2];
    			if(dateYear.length === 2){ //check for abbreviated date
    				dateYear = "20"+dateYear;
    			}
    			dateConcat = dateYear+"-"+datepartsOne[0]+"-"+datepartsOne[1];
    			dateOne = new Date(dateConcat);
    		}else{
    			if(datepartsOne[0].indexOf("/") !== -1){ //same operations as above
    				dateYear = datepartsOne[1];
    				if(dateYear.length === 2){
    					dateYear = "20"+dateYear;
    				}
    				let monthDay = datepartsOne[0].split("/");
    				dateConcat = dateYear+"-"+monthDay[0]+"-"+monthDay[1];
    				dateOne = new Date(dateConcat);
    			}else{
    				let dateparts2 = datepartsOne[1].split("/");
    				dateYear = dateparts2[1];
    				if(dateYear.length === 2){
    					dateYear = "20"+dateYear;
    				}
    				dateConcat = dateYear+"-"+datepartsOne[0]+"-"+dateparts2[0];
    				dateOne = new Date(dateConcat);
    			}
    		}
    	}
    	return dateOne;
	}

	componentDidMount(){
		this.getOrders();
	}

	getOrders(){
		let parameters;
		let d = new Date();
		if(this.state.year === ''){ //if year is not set, set year
			this.setState({year:d.getFullYear()});
		}
		if(this.props.userInfo.userType !== "asm_admin" && this.props.userInfo.userType !== "sys_admin" && this.props.view !== "regional"){ //parameters for an asm or asm_regional to view their personal orders
			parameters = {
				endpoint:'info',
				table:'asm_orders',
				action:'user',
				userID:this.props.userInfo.userID,
				year:d.getFullYear()
			};
		}else if(this.props.userInfo.userType === "asm_regional" && this.props.view === "regional"){ //parameters for asm_regional to view pending orders that have passed their threshold
			parameters = {
				endpoint:'info',
				table:'asm_orders',
				action:'regional',
				year:d.getFullYear(),
				userID:this.props.userInfo.userID
			};
		}else if(this.props.userInfo.userType === "asm_admin" || this.props.userInfo.userType === "sys_admin"){ //parameters or asm_admin to view orders
			if(this.props.view === "history"){ //parameters for asm_admin viewing order history (orders that have already been accepted/fulfilled)
				let year,month,day,start,end;
				if(this.state.startDate === '' && this.state.endDate === ''){
					year = d.getFullYear();
					month = d.getMonth() <= 2?1:d.getMonth() - 2;
					day = d.getDate();
					if(month == 1){
						day = 1;
					}
					start = month+"/"+day+"/"+year;
					month = Number(month) + 3;
					month = month.toString();
					end = month+"/"+day+"/"+year;
					this.setState({startDate:start,endDate:end});
				}else{
					start = this.state.startDate;
					end = this.state.endDate;
				}
				let startDate = start;
				let endDate = end;
				parameters = {
					endpoint:'info',
					table:'asm_orders',
					action:'history',
					year:year,
					kind:startDate,
					name:endDate
				};
			}else{ //parameters for asm_admin to view pending orders
				parameters = {
					endpoint:'info',
					table:'asm_orders',
					action:'admin',
					year:d.getFullYear()
				};
			}
		}
		axios({ //retrieve orders from database 
			method:'post',
			url:path,
			headers:{'Content-Type':'application/json'},
			data:parameters
		}).then((response)=>{
			let orderitem = {};
			let orderInfo = [];
			const userInfo = this.props.userInfo;
			let data = response.data.data;
			if(data !== undefined){
				data.forEach((item)=>{ //consolidate general order info and order line items
					if(userInfo.userType === "asm"){
						const status = item.order_status === "pending_admin"?"pending (admin order)":item.order_status;
						orderInfo.push({
							ID:item.ID,
							cost:item.cost,
							Date:item.Date,
							status:status,
							notes:item.notes,
							costcenter:item.costcenter,
							address:item.address,
							city:item.city,
							state:item.state,
							zipcode:item.zipcode,
							instructions:item.instructions,
							tracking_number:item.tracking_number,
							items:[]
						});
					}else{
						orderInfo.push({
							ID:item.ID,
							cost:item.cost,
							Date:item.Date,
							status:item.order_status,
							notes:item.notes,
							name:item.name,
							email:item.email,
							costcenter:item.costcenter,
							address:item.address,
							city:item.city,
							state:item.state,
							zipcode:item.zipcode,
							instructions:item.instructions,
							tracking_number:item.tracking_number,
							items:[]
						});
					}
				});
				let orders = orderInfo.filter(obj => !orderitem[obj.ID] && (orderitem[obj.ID] = true));
				let orderSize, orderColor;
				orders.forEach((order)=>{
					data.forEach((orderItem)=>{
						if(orderItem.ID === order.ID){
							orderSize = orderItem.size === null?"N/A":orderItem.size;
							orderColor = orderItem.color === null?"N/A":orderItem.color;
							order.items.push({
								prize:orderItem.prize,
								item_cost:orderItem.item_cost,
								quantity:orderItem.quantity,
								prizeID:orderItem.prizeID,
								variantID:orderItem.variantID,
								size:orderSize,
								color:orderColor.replace(/_/g," ")
							});
						}
					});
				});
				this.setState({orders:orders});
			}
		});
	}

	// componentDidUpdate(prevProps){ //if an order is placed in gift shop or cancelled, retrieve updated order information
	// 	if(prevProps.submitted !== this.props.submitted){
	// 		this.getOrders();
	// 	}
	// }

	handleInput(identity,value){ //method for handling start and end date input fields
		const theState = {};
		if(/^(\s*|[0-9/-]*)$/g.test(value)){ //only allow blank input or numbers, slashes, and dashes
			theState[identity] = value;
			this.setState(theState);
		}
	}

	handleSubmit(){
		let modalPrompt = ''
		if(Validation("date",this.state.startDate) && Validation("date",this.state.endDate)){ //make sure start date and end date are valid date formats
			if(this.createDateObject(this.state.startDate) <= this.createDateObject(this.state.endDate)){ //make sure dates are real and start date is before end date
				this.getOrders(); //get orders in that date range
			}else{
				modalPrompt += 'End date must be the same as, or greater than the Start date.';
				this.setState({modalPrompt:modalPrompt,modalIsOpen:true});
			}
		}else{ //error messages for invalid date formats
			if(!Validation("date",this.state.startDate)){
				modalPrompt += 'Start Date is invalid. ';
			}
			if(!Validation("date",this.state.endDate)){
				modalPrompt += 'End Date is invalid. ';
			}
			this.setState({modalPrompt:modalPrompt,modalIsOpen:true});
		}
	}

	loadingFunc(loading){ //method for opening modal and displaying loading gif
		if(loading){
			this.setState({loading:true},function(){
				this.openModal();
			});
		}else{
			this.setState({loading:false},function(){
				this.closeModal();
			});
		}
	}
	componentDidUpdate(prevProps,prevState){
		if(prevProps.approval !== this.props.approval){ //retrieve new set of orders if asm_regional updates their settings for approval (manual or automatic)
			this.setState({approval:this.props.approval});
			if(prevProps.approval !== ''){
				this.getOrders();
			}
		}
		if(prevProps.view !== this.props.view && this.props.active){ //get orders based on view change since component is used in multiple views (i.e. asm_regional viewing their personal orders or pending orders)
			this.getOrders();
		}
		if(prevProps.submitted !== this.props.submitted){ //if user submits or cancels an order, retrieve updated order info
			this.getOrders();
		}
	}

	orderChangeEmail(status,order){ //method for sending email once an order is fulfilled, denied, or cancelled
		let params,date,name,email;
		// this.state.orders.forEach((order)=>{
		// 	if(Number(order.ID) === Number(id)){
		// 		date = order.Date;
		// 	}
		// });
		date = order.Date;
		const thestatus = status === "cancel"?"cancelled":status;
		if(this.props.userInfo.userType === 'asm'){ //email asm confirmation that their order has been cancelled
			params = {
				'action':'asmOrder',
				'name':this.props.userInfo.name,
				'email':this.props.userInfo.email,
				'status':thestatus,
				'date':date,
				'orderItems':order.items,
				'shippingInfo':{
					'street_address':order.address,
					'city':order.city,
					'state':order.state,
					'zipcode':order.zipcode,
					'shipping_instructions':order.instructions
				},
				'notes':order.notes
			};
		}else{ //email the asm who's order has just been fulfilled or denied
			// this.state.orders.forEach((order)=>{
			// 	if(Number(order.ID) === Number(id)){
			// 		name = order.name;
			// 		email = order.email;
			// 	}
			// });
			name = order.name;
			email = order.email;
			params = {
				'action':'asmOrder',
				'name':name,
				'email':email,
				'status':thestatus,
				'date':date,
				'orderItems':order.items,
				'shippingInfo':{
					'street_address':order.address,
					'city':order.city,
					'state':order.state,
					'zipcode':order.zipcode,
					'shipping_instructions':order.instructions
				},
				'notes':order.notes
			};
		}
		axios({
			method:'post',
			url:mail,
			headers:{'Content-Type':'application/json'},
			data:params
		});
	}

	changeStatus(status,order){ //method that handles changing the status of an order
		this.loadingFunc(true);
		let orders = this.state.orders;
		axios({
			method:'post',
			url:path,
			headers:{'Content-Type':'application/json'},
			data:{
				endpoint:'create',
				table:'asm_order',
				misc:'status',
				status:status,
				firstID:order.ID
			}//firstID:id}
		}).then((response)=>{
			this.loadingFunc(false);
			this.orderChangeEmail(status,order); //ORDER CHANGE EMAIL
			if(this.props.userInfo.userType !== 'asm_admin' && this.props.userInfo.userType !== "sys_admin" && this.props.userInfo.userType !== 'user'){
				this.props.budgetUpdate("add",order.cost,false);
			}
			if(status === "cancel" || status === "denied"){
				let canceled = [order];
				// orders.map((order)=>{
				// 	if(order.ID == id){
				// 		canceled.push(order);
				// 	}
				// });
				let cancelItems = [];
				canceled[0].items.forEach((item)=>{ //update the available quantity of each gift in an order that has been denied or cancelled
					cancelItems.push(axios({
						method:'post',
						url:path,
						headers:{'Content-Type':'application/json'},
						data:{
							endpoint:'create',
							table:'inventory',
							misc:'_cancel',
							quantity:item.quantity,
							firstID:item.variantID
						}
					}));
				});
				axios.all(cancelItems).then((res)=>{
					this.props.logChange();
				})
			}else{
				this.props.logChange();
			}
		});
	}

	onclick(e){ //method that handles button click (cancel, deny, or fulfill)
		let val = e.currentTarget.value;
		let orderID = e.currentTarget.name;
		if(val === "cancel"){
			this.setState({cancelID:orderID},function(){
				this.openModal();
			});
		}else{
			let theorder;
			const newOrders = [];
			this.state.orders.forEach((order)=>{
				if(Number(order.ID) !== Number(orderID)){
					newOrders.push(order);
				}else{
					theorder = order;
				}
			});
			this.changeStatus(val,theorder);
			this.setState({orders:newOrders});
		}
	}

	openModal() { //open the modal
    	this.setState({modalIsOpen: true});
  }

	closeModal() { //close the modal
	    this.setState({modalIsOpen: false});
	}

	cancelOrder(){ //method that handles cancel order operations, called when user confirms they wish to cancel an order
		this.closeModal();
		let theorder;
		const {orders,cancelID} = this.state;
		const newOrders = [];
		orders.forEach((order)=>{
			if(Number(order.ID) !== Number(cancelID)){
				newOrders.push(order);
			}else{
				theorder = order;
			}
		});
		this.changeStatus("cancel",theorder);
		this.setState({orders:newOrders});
	}

	editTrackingNumber(e){
		let id_strings = e.target.id.split("_");
		let id = id_strings[0];
		let orderID = id_strings[1];
		let tracking_number = document.getElementById(e.target.id).textContent;
		document.getElementById(e.target.id).style.fontWeight = "bold";
		if(/^[a-zA-Z0-9\-\/]{1,}$/g.test(tracking_number)){
			document.getElementById(e.target.id).style.color = "green";
			let orders = this.state.orders;
			orders[id].tracking_number = tracking_number;
			this.setState({orders:orders});
			axios({
				method:'post',
				url:path,
				headers:{'Content-Type':'application/json'},
				data:{endpoint:'create',table:'asm_order',misc:'tracking',status:tracking_number,firstID:orderID}
			});
		}else{
			document.getElementById(e.target.id).style.color = "red";
		}
	}

	render(){
		let content;
		let cutoffDate;
		const inputStyles = "pl2 pr2 h2 br2 bw1 w-90 shadow-3";
		if(this.props.view === "history"){ //start date and end date input fields for asm_admin to filter orders
			cutoffDate =<div className="fl w-100 pb3 mb3">
							<div className="fl w-100">
								<div className="fl w-40 pr2">
									<label className="b navy mt2">Start Date:</label>
									<Input type="text" id="start" inputStyle={inputStyles} identity="startDate" onInput={this.handleInput} val={this.state.startDate}/>
								</div>
								<div className="fl w-40">
									<label className="b navy mt2">End Date:</label>
									<Input type="text" id="end" inputStyle={inputStyles} identity="endDate" onInput={this.handleInput} val={this.state.endDate}/>
								</div>
								<div className="fl w-20">
									<button onClick={this.handleSubmit} className="b white bg-navy pa2 br3 tc w-100 mt3">Submit</button>
								</div>
							</div>
						</div>;
		}
		let columnsTop;
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'400px',
		    minWidth:'300px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    //backgroundColor:'#F4F4F4',
		    transform: 'translate(-50%, -50%)',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		const approve = {
			backgroundImage: 'url('+checkmark+')',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			backgroundColor: 'white',
			backgroundSize: '35px 25px',
			minWidth: '40px',
			minHeight:'30px'
		};
		const deny = {
			backgroundImage: 'url('+denied+')',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			backgroundColor: 'white',
			backgroundSize: '35px 25px',
			minWidth: '40px',
			minHeight:'30px'
		};
		const orders = this.state.orders;
		const columnHeads = ["Gift","Unit Cost","Quantity","size","color"];
		let orderhistory;
		if(orders.length > 0){
			let tracking;
			orderhistory = orders.map((orders,i)=>{ //map and consolidate orders 
				const costcenter = orders.costcenter;
				const address_city_state_zip = orders.address+", "+orders.city+", "+orders.state+" "+orders.zipcode;
				const notes = (orders.notes === null || orders.notes === '')?"None":orders.notes;
				const instructions = (orders.instructions === null || orders.instructions === '')?"None":orders.instructions;
				const tracking_number = (orders.tracking_number === null || orders.tracking_number === '')?"None":orders.tracking_number;
				const items = orders.items.map((item)=>{ //get relevant line item information
					return {
						prize: item.prize,
						cost: "$"+item.item_cost,
						quantity: item.quantity,
						size: item.size,
						color: item.color
					};
				});
				const orderitems = items.map((items,i)=>{ //display line items in table format
					return (
						<TableData 
							key={i}
							columns={items}
							cellstyle="ba tc pa1"
							rowstyle="stripe-blue"
						/>
					)
				});
				if(this.props.userInfo.userType !== "asm"){ //following block is for asm_regionals and asm_admin viewing pending orders
					const buttonVal = this.props.view === "regional"?"pending":"fulfilled";
					let buttons;
					if((orders.status !== "fulfilled") && this.props.view !== "user"){ //display fulfill and deny buttons
						if(this.props.approval !== "automatic"){ //if asm_regional has chosen to manually approve orders that pass their threshold
							buttons = <div className="fl w-25 b mt2"><button className="fr br3" name={orders.ID} value={buttonVal} onClick={this.onclick} style={approve}></button>
											<button className="fr br3" name={orders.ID} value="denied" onClick={this.onclick} style={deny}></button></div>;
						}
						columnsTop= <div className="fl w-100 ba br--top br3 br bl pl2 pr2">
												<p className="fl w-25 b">Date: {orders.Date}</p>
												<p className="fl w-25 b">Total Cost: ${orders.cost}</p>
												<p className="fl w-25 b">Name: {orders.name}</p>
												{buttons}
											</div>;	
					}else if(this.props.view === "user"){ //order headers for viewing personal orders
						if(orders.status !== "pending"){
							columnsTop= <div className="fl w-100 ba br--top br3 br bl pl2">
														<p className="fl w-33 b">Date: {orders.Date}</p>
														<p className="fl w-33 b">Total Cost: ${orders.cost}</p>
														<p className="fl w-33 b">Status: {orders.status}</p>
													</div>;	
						}else{
							columnsTop= <div className="fl w-100 ba br--top br3 br bl pl2">
														<p className="fl w-30 b">Date: {orders.Date}</p>
														<p className="fl w-30 b">Total Cost: ${orders.cost}</p>
														<p className="fl w-30 b">Status: {orders.status}</p>
														<div className="fl w-10 pr2">
															<button className="fr br3 mt2 white bg-navy b" name={orders.ID} value="cancel" onClick={this.onclick}>cancel</button>
														</div>
													</div>;
						}
					}else if(this.props.view === "history"){ //order headers for asm_admin viewing fulfilled orders
						let track_id = i+"_"+orders.ID;
						tracking = <p className="bb pl2 pr2 pb3"><span className="b pr1" style={{display:'inline-block'}}>Tracking Number: </span><span style={{display:'inline-block'}} id={track_id} onBlur={this.editTrackingNumber} contentEditable={true}>{tracking_number}</span></p>;
						columnsTop= <div className="fl w-100 ba br--top br3 br bl pl2 pr2">
												<p className="fl w-25 b">Date: {orders.Date}</p>
												<p className="fl w-25 b">Total Cost: ${orders.cost}</p>
												<p className="fl w-25 b">Name: {orders.name}</p>
												{buttons}
											</div>;
					}
					
				}else{
					if(orders.status !== "pending"){ //headers for already fulfilled orders
						if(orders.status === "fulfilled"){
							tracking = <p className="bb pl2 pr2 pb3"><span className="b">Tracking Number: </span>{tracking_number}</p>;
						}
						columnsTop= <div className="fl w-100 ba br--top br3 br bl pl2">
													<p className="fl w-33 b">Date: {orders.Date}</p>
													<p className="fl w-33 b">Total Cost: ${orders.cost}</p>
													<p className="fl w-33 b">Status: {orders.status}</p>
												</div>;	
					}else{ //headers for pending orders
						columnsTop= <div className="fl w-100 ba br--top br3 br bl pl2">
													<p className="fl w-30 b">Date: {orders.Date}</p>
													<p className="fl w-30 b">Total Cost: ${orders.cost}</p>
													<p className="fl w-30 b">Status: {orders.status}</p>
													<div className="fl w-10 pr2">
														<button className="fr br3 mt2 white bg-navy b" name={orders.ID} value="cancel" onClick={this.onclick}>cancel</button>
													</div>
												</div>;
					}
				}
				return(
					<div className="fl w-100 mv3 br3 shadow-3 bg-white" key={i}>
						{columnsTop}
						<table className="fl w-100 collapse mb2">
							<thead className="collapse">
								<TableHead columns={columnHeads} headstyle="ba pa1"/>
							</thead>
							<tbody className="bb bw1">
								{orderitems}
							</tbody>
						</table>
						<div className="bl br bb br--bottom br3">
							<p className="bb pl2 pr2 pb1"><span className="b">Cost center: </span>{costcenter}</p>
							<p className="bb pl2 pr2 pb3"><span className="b">Ship To: </span>{address_city_state_zip}</p>
							{tracking}
							<p className="mt3 pl2 pr2 bb pb3"><span className="b">Shipping Instructions: </span>{instructions}</p>
							<p className="mt3 pl2 pr2"><span className="b">Event Details: </span>{notes}</p>
						</div>
					</div>
				)
			});
		}
		let modalContent;
		if(this.state.loading){ //display loading gif
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}else if(this.props.view !== "history"){ //modal prompt for when a user wishes to cancel an order
			modalContent = <div>
												<div className="fl w-100 tr">
								        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
								        </div>
												<div className="fl w-100">
								        	<div>
								        		<p className="navy b tc f4">Are you sure you would like to cancel this order?</p>
								        	</div>
								        	<div className="fl w-100">
								        		<div className="fl w-50 tc">
								        			<button onClick={this.cancelOrder} className="w-50-ns w-100 bg-navy b white br2">Yes</button>
								        		</div>
								        		<div className="fl w-50 tc">
								        			<button onClick={this.closeModal} className="w-50-ns w-100 bg-navy b white br2">No</button>
								        		</div>
								        	</div>
								        </div>
							        </div>;
		}else{ //display message
			modalContent = <div>
												<div className="fl w-100 tr">
								        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
								        </div>
								        <p className="navy b f4 tc pt2">{this.state.modalPrompt}</p>
								     </div>;
		}
		if(this.props.active){
			if(orders.length < 1){
				orderhistory = <p className="w-100 f3 tc mv3">There is nothing to view at this time.</p>;
			}
			content = <div>
									{cutoffDate}
									<div>
										{orderhistory}
									</div>
									<div>
										<Modal
							          isOpen={this.state.modalIsOpen}
							          style={customStyles}
							          contentLabel="shopping cart Modal"
							          shouldCloseOnOverlayClick={false}
							          shouldCloseOnEsc={false}
							        >
							        {modalContent}
							        </Modal>
									</div>
								</div>;
		}
		return (
			<div>
			{content}
			</div>
		);
	}
}

// <div className="fl w-33">
// 												<div className="fl w-100">
// 													<label className="b navy mt2">Cut-off Month:</label>
// 												</div>
// 												<div className="fl w-100 pr2">
// 													<SelectBox identity="month" options={months} onSelect={this.handleInput} styles={inputStyles} val={this.state.month} type="Month"/>
// 												</div>
// 											</div>
// 											<div className="fl w-33">
// 												<div className="fl w-100">
// 													<label className="b navy mt2">Cut-off Day:</label>
// 												</div>
// 												<div className="fl w-100 pr2">
// 													<SelectBox identity="day" options={this.state.days} onSelect={this.handleInput} styles={inputStyles} val={this.state.day} type="Day"/>
// 												</div>
// 											</div>
// 											<div className="fl w-33">
// 												<div className="fl w-100">
// 													<label className="b navy mt2">Year:</label>
// 												</div>
// 												<div className="fl w-100 pr2">
// 													<SelectBox identity="year" options={this.state.years} onSelect={this.handleInput} styles={inputStyles} val={this.state.year} type="Year"/>
// 												</div>
// 											</div>


		// console.log(identity,value);
		// if(identity === "month"){
		// 	let year = this.state.year;
		// 	theState['days'] = this.getDays(value,year);
		// 	theState['day'] = '01';
		// }else if(identity === "year"){
		// 	theState['days'] = this.getDays(theState['month'],value);
		// 	theState['day'] = '01';
		// 	theState['year'] = value;
		// }


// WEBPACK FOOTER //
// ./src/container/ViewASMOrders.js